import {
  UPDATE_MANAGER_SHIFT_REQUEST,
  UPDATE_MANAGER_SHIFT_SUCCESS,
  UPDATE_MANAGER_SHIFT_FAILURE,
  ADD_MANAGER_SHIFT_REQUEST,
  ADD_MANAGER_SHIFT_SUCCESS,
  ADD_MANAGER_SHIFT_FAILURE,
  DELETE_MANAGER_SHIFT_REQUEST,
  DELETE_MANAGER_SHIFT_SUCCESS,
  DELETE_MANAGER_SHIFT_FAILURE
} from "../../Constants";

import { managerTimesheet } from "../../Api/managerTimesheet";

function requestUpdateShift() {
  return {
    type: UPDATE_MANAGER_SHIFT_REQUEST,
    isFetching: true
  };
}

function updateShiftSuccess(data) {
  return {
    type: UPDATE_MANAGER_SHIFT_SUCCESS,
    isFetching: false,
    data
  };
}

function updateShiftError(errorMessage) {
  return {
    type: UPDATE_MANAGER_SHIFT_FAILURE,
    isFetching: false,
    errorMessage
  };
}

function requestaddShift() {
  return {
    type: ADD_MANAGER_SHIFT_REQUEST,
    isFetching: true
  };
}

function addShiftSuccess(data) {
  return {
    type: ADD_MANAGER_SHIFT_SUCCESS,
    isFetching: false,
    data
  };
}

function addShiftError(errorMessage) {
  return {
    type: ADD_MANAGER_SHIFT_FAILURE,
    isFetching: false,
    errorMessage
  };
}

function requestDeleteShift() {
  return {
    type: DELETE_MANAGER_SHIFT_REQUEST,
    isFetching: true
  };
}

function deleteShiftSuccess(data) {
  return {
    type: DELETE_MANAGER_SHIFT_SUCCESS,
    isFetching: false,
    data
  };
}

function deleteShiftError(errorMessage) {
  return {
    type: DELETE_MANAGER_SHIFT_FAILURE,
    isFetching: false,
    errorMessage
  };
}

export const updateManagerShift = payload => (dispatch, getState) => {
  dispatch(requestUpdateShift());
  managerTimesheet
    .updateShiftManager(payload)
    .then(res => {
      dispatch(updateShiftSuccess(res));
    })
    .catch(err => dispatch(updateShiftError(err)));
};

export const addManagerShift = payload => (dispatch, getState) => {
  dispatch(requestaddShift());
  managerTimesheet
    .addShiftManager(payload)
    .then(res => {
      dispatch(addShiftSuccess(res));
    })
    .catch(err => dispatch(addShiftError(err)));
};

export const deleteManagerShift = payload => (dispatch, getState) => {
  dispatch(requestDeleteShift());
  managerTimesheet
    .deleteShiftManager(payload)
    .then(res => {
      dispatch(deleteShiftSuccess(res));
    })
    .catch(err => dispatch(deleteShiftError(err)));
};

export const resetShiftMessage = payload => (dispatch, getState) => {
  dispatch(addShiftSuccess(""));
};
